'use client';

import { c as _c } from "react/compiler-runtime";
import type { Role } from '@svs/nova-core/nextjs/auth';
import { useDialog } from '@svs/nova-foundation/nextjs/dialog';
import { ConsumerProvider } from '@svs/nova-poolbetting/core/frameworks/nextjs/components';
import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';
type EventConsumerProviderProps = PropsWithChildren<{
  role?: Promise<Role | undefined>;
}>;

/**
 * Event consumer provider for Powerplay, used to handle events in the application.
 *
 * @param root0 props
 * @param root0.children jsx children
 * @param root0.role promise resolving to the role of the current user (e.g., 'Retailer', 'Player')
 * @returns event consumer provider component
 */
export function EventConsumerProvider(t0) {
  const $ = _c(6);
  const {
    children,
    role
  } = t0;
  const {
    showDialog
  } = useDialog();
  let t1;
  if ($[0] !== role || $[1] !== showDialog) {
    t1 = {
      async hasMaxCoupons() {
        if ((await role) === "Retailer") {
          return "resetAllCoupons";
        }
        return new Promise(resolve => void showDialog({
          title: "Du har maximalt antal p\xE5b\xF6rjade kuponger",
          description: "V\xE4nligen ta bort en kupong eller ers\xE4tt dessa med den nya",
          buttons: {
            primary: {
              label: "Ok",
              action: () => {
                resolve("doNothing");
              }
            },
            secondary: {
              label: "Rensa och ers\xE4tt alla kuponger",
              action: () => {
                resolve("resetAllCoupons");
              }
            }
          }
        }));
      },
      async hasPopulatedCoupons() {
        if ((await role) === "Retailer") {
          return "resetAllCoupons";
        }
        return new Promise(resolve_0 => void showDialog({
          title: "Du har redan p\xE5b\xF6rjade kuponger",
          description: "Vad vill du g\xF6ra?",
          buttons: {
            primary: {
              label: "L\xE4gg till en ny kupong",
              action: () => {
                resolve_0("addNewCoupon");
              }
            },
            secondary: {
              label: "Rensa och ers\xE4tt alla kuponger",
              action: () => {
                resolve_0("resetAllCoupons");
              }
            }
          }
        }));
      }
    };
    $[0] = role;
    $[1] = showDialog;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCallbackFn2 = t1;
  let t2;
  if ($[3] !== children || $[4] !== handleCallbackFn2) {
    t2 = <ConsumerProvider callbackFn={handleCallbackFn2}>{children}</ConsumerProvider>;
    $[3] = children;
    $[4] = handleCallbackFn2;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}